import { render, staticRenderFns } from "./promoProductList.vue?vue&type=template&id=2f1d20d9"
import script from "./promoProductList.vue?vue&type=script&lang=js"
export * from "./promoProductList.vue?vue&type=script&lang=js"
import style0 from "./promoProductList.vue?vue&type=style&index=0&id=2f1d20d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports